const PageNotFound = () => {
   return (
      <div className="pageViewContainer">
         <h1>404: Page does not exist</h1>
      </div>
   )
}

export default PageNotFound
